import React from "react";
import { getOSSImage } from "./Utils";

import '../css/Experiences.css';

const titleImage = getOSSImage('zi_title_yonghutiyan.png');
const contentImage = getOSSImage('yonghutiyan.png');

export default function Experiences() {
    return(
        <div id="experiences" className="experiences-container">
            <img className="experiences-tile" alt="experiences-title" src={titleImage}/>
            <img className="experiences-value" alt="experiences-value" src={contentImage}/>
        </div>
    )
}